// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `tbody.loading {
	animation: opacity 1.5s infinite normal;
}

@keyframes opacity {
	0% {
		opacity: 0.8;
	}
	50% {
		opacity: 0.3;
	}
	100% {
		opacity: 0.8;
	}
}
`, "",{"version":3,"sources":["webpack://./src/shared/DataTable/DataTable.css"],"names":[],"mappings":"AAAA;CAEC,uCAAuC;AACxC;;AAcA;CACC;EACC,YAAY;CACb;CACA;EACC,YAAY;CACb;CACA;EACC,YAAY;CACb;AACD","sourcesContent":["tbody.loading {\n\t-webkit-animation: opacity 1.5s infinite normal;\n\tanimation: opacity 1.5s infinite normal;\n}\n\n@-webkit-keyframes opacity {\n\t0% {\n\t\topacity: 0.8;\n\t}\n\t50% {\n\t\topacity: 0.3;\n\t}\n\t100% {\n\t\topacity: 0.8;\n\t}\n}\n\n@keyframes opacity {\n\t0% {\n\t\topacity: 0.8;\n\t}\n\t50% {\n\t\topacity: 0.3;\n\t}\n\t100% {\n\t\topacity: 0.8;\n\t}\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
